module.exports = __webpack_public_path__ + "a2e4e87cda11c664073e86a99bbfef98.woff2";